// client/src/routes/app/contracts/$contractId/deposit.tsx — SCR-CON-003 tab „Garanție" ·
// CON-005 phase 1 (the seam), phase 2 (CON-003's status machine).
//
// The garanție AMOUNT is not waiting for anything — `depositMonths` is a term of the contract,
// collected by the wizard's fourth step and shown on the Termeni tab. What waits here is
// CON-003's `DepositStatus` machine and its transitions (`/contracts/{id}/deposit`, `retain`,
// `return`), which is not on develop as phase 1 is written. CON-003's own D-626 records the
// other side of this seam: it shipped no client work because this screen is CON-005's.

import { createFileRoute } from '@tanstack/react-router';

import { ErrorState, LoadingState } from '@/components/ui/states';
import { DepositPanel } from '@/features/contracts/panels';
import { useContract } from '@/features/contracts/queries';
import { wireNumber } from '@/lib/wire';

export const Route = createFileRoute('/app/contracts/$contractId/deposit')({
  component: DepositTabScreen,
});

function DepositTabScreen() {
  const { contractId } = Route.useParams();
  const contract = useContract(contractId);

  if (contract.isPending) return <LoadingState rows={2} />;
  if (contract.isError) return <ErrorState error={contract.error} onRetry={() => void contract.refetch()} />;

  return (
    <DepositPanel
      contractId={contractId}
      propertyId={contract.data.propertyId}
      depositMonths={wireNumber(contract.data.depositMonths)}
      currency={contract.data.rentCurrency}
    />
  );
}
